import axios from 'axios';
import { retrieveAccessToken } from '../../../../shared/infra/auth/RetrieveAccessToken';

export async function findCourse(courseId) {
  const accessToken = await retrieveAccessToken({ required: false });
  const response = await axios.get(`/api/viewer/course/${encodeURIComponent(courseId)}`, {
    headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {}
  });
  return response.data;
}
